module.exports = __webpack_public_path__ + "img/image_12.76ee7f64.png";